import React from "react";
import { Button, Tooltip, useTheme } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const baseSx = {
  fontWeight: 500,
  borderRadius: "8px",
  textTransform: "none",
  fontSize: "14px",
  px: 2,
  py: 1,
};

const ScopeActionButton = ({
  mode,
  onClick,
  disabled = false,
  disabledReason = "",
  label,
  startIcon,
  sx = {},
}) => {
  const theme = useTheme();
  const isOut = mode === "out";
  const text = label || (isOut ? "Mark Out of Scope" : "Mark In Scope");
  const icon =
    startIcon ??
    (isOut ? (
      <RemoveCircleOutlineIcon sx={{ fontSize: 16 }} />
    ) : (
      <AddCircleOutlineIcon sx={{ fontSize: 16 }} />
    ));

  const colorSx = isOut
    ? {
        bgcolor: theme.customColors.status.error.main,
        color: "#fff",
        "&:hover": { bgcolor: theme.customColors.status.error.text },
      }
    : {
        bgcolor: theme.customColors.button.primary,
        color: theme.customColors.button.text,
        "&:hover": {
          bgcolor:
            theme.palette._blue?.dark || theme.customColors.button.primary,
        },
      };

  const button = (
    <Button
      variant="contained"
      startIcon={icon}
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...baseSx,
        ...colorSx,
        "&:disabled": {
          bgcolor: theme.customColors.background.light,
          color: theme.customColors.text.disabled,
        },
        ...sx,
      }}
    >
      {text}
    </Button>
  );

  if (!disabledReason) return button;

  return (
    <Tooltip title={disabledReason} arrow disableHoverListener={!disabled}>
      <span>{button}</span>
    </Tooltip>
  );
};

export default ScopeActionButton;
